var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOvercast01 = function SvgOvercast01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "overcast-01_svg2__a",
    x1: 39.13,
    x2: 169.2,
    y1: 192.21,
    y2: 59.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overcast-01_svg2__a",
    id: "overcast-01_svg2__b",
    x1: -28.49,
    x2: 101.58,
    y1: 126.02,
    y2: -6.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overcast-01_svg2__a",
    id: "overcast-01_svg2__c",
    x1: -34.66,
    x2: 95.41,
    y1: 119.98,
    y2: -12.91,
    gradientTransform: "rotate(22.49 57.804 25.525)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overcast-01_svg2__a",
    id: "overcast-01_svg2__d",
    x1: -35.01,
    x2: 95.06,
    y1: 119.64,
    y2: -13.25,
    gradientTransform: "rotate(67.5 25.51 57.813)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overcast-01_svg2__a",
    id: "overcast-01_svg2__e",
    x1: -12.18,
    x2: 117.89,
    y1: 141.99,
    y2: 9.09,
    gradientTransform: "rotate(22.51 25.499 103.455)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overcast-01_svg2__a",
    id: "overcast-01_svg2__f",
    x1: -11.33,
    x2: 118.74,
    y1: 142.82,
    y2: 9.92,
    gradientTransform: "rotate(67.49 103.483 25.519)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overcast-01_svg2__a",
    id: "overcast-01_svg2__g",
    x1: -42.69,
    x2: 87.38,
    y1: 112.12,
    y2: -20.77,
    gradientTransform: "rotate(45 33.888 33.877)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overcast-01_svg2__a",
    id: "overcast-01_svg2__h",
    x1: -29.21,
    x2: 100.86,
    y1: 125.32,
    y2: -7.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overcast-01_svg2__a",
    id: "overcast-01_svg2__i",
    x1: 5.08,
    x2: 135.15,
    y1: 158.87,
    y2: 25.98,
    gradientTransform: "rotate(44.99 127.42 33.898)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.2 117.29c.81-3.54 1.22-7.17 1.22-10.84 0-26.68-21.71-48.39-48.39-48.39-3 0-5.94.31-8.81.85-7.88-14.3-23.14-23.43-39.57-23.43-24.9 0-45.16 20.26-45.16 45.16 0 7.9 2.07 15.58 5.96 22.38-2.65 3.97-4.54 8.48-5.41 13.36-1.25-.14-2.51-.25-3.77-.25C14.47 116.13 0 130.6 0 148.39s14.47 32.26 32.26 32.26h22.58c0 10.67 8.68 19.35 19.36 19.35h51.61c10.67 0 19.36-8.68 19.36-19.35h22.58c17.79 0 32.26-14.47 32.26-32.26 0-14.86-10.11-27.37-23.8-31.1ZM80.65 41.94c13.52 0 26.12 7.22 33.08 18.64-13.64 4.59-24.86 15.15-30.02 28.93-4.01-1.55-8.32-2.41-12.74-2.41-9.74 0-18.63 4.03-25.1 10.52a38.6 38.6 0 0 1-3.94-16.97c0-21.35 17.36-38.71 38.71-38.71Zm45.16 151.61H74.2c-7.12 0-12.9-5.79-12.9-12.9s5.79-12.9 12.9-12.9c1.23 0 2.54.23 4 .71l2.82.92 1.15-2.73c3.04-7.17 10.04-11.81 17.83-11.81s14.79 4.64 17.83 11.81l1.15 2.73 2.82-.92c1.47-.48 2.78-.71 4.01-.71 7.12 0 12.9 5.79 12.9 12.9s-5.79 12.9-12.9 12.9m41.93-19.36h-23.71c-2.66-7.51-9.82-12.9-18.23-12.9-1.07 0-2.16.1-3.27.32-4.52-8.12-13.09-13.22-22.53-13.22s-18.01 5.11-22.53 13.22c-1.12-.22-2.2-.32-3.27-.32-8.41 0-15.56 5.4-18.23 12.9H32.26c-14.23 0-25.81-11.58-25.81-25.81s11.58-25.81 25.81-25.81c5.98 0 11.58 1.98 16.22 5.73l4.06-5.02c-3.04-2.46-6.51-4.31-10.2-5.53 2.31-13.78 14.41-24.22 28.63-24.22 11.06 0 21.32 6.44 26.14 16.39l5.81-2.81c-2.99-6.18-7.7-11.24-13.38-14.73 5.89-16.53 21.77-27.88 39.49-27.88 23.12 0 41.94 18.81 41.94 41.94 0 3.32-.4 6.59-1.16 9.78-.69-.04-1.37-.1-2.07-.1-17.79 0-32.26 14.47-32.26 32.26h6.45c0-14.23 11.58-25.81 25.81-25.81s25.81 11.58 25.81 25.81-11.58 25.81-25.81 25.81",
    style: {
      fill: "url(#overcast-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.42 0h6.45v29.03h-6.45z",
    style: {
      fill: "url(#overcast-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.58 17.45h6.45v16.13h-6.45z",
    style: {
      fill: "url(#overcast-01_svg2__c)"
    },
    transform: "rotate(-22.49 57.801 25.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.28 49.74h6.45v16.13h-6.45z",
    style: {
      fill: "url(#overcast-01_svg2__d)"
    },
    transform: "rotate(-67.5 25.514 57.811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.44 100.26h16.13v6.45H17.44z",
    style: {
      fill: "url(#overcast-01_svg2__e)"
    },
    transform: "rotate(-22.51 25.511 103.472)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.42 22.29h16.13v6.45H95.42z",
    style: {
      fill: "url(#overcast-01_svg2__f)"
    },
    transform: "rotate(-67.49 103.49 25.513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.66 19.37h6.45V48.4h-6.45z",
    style: {
      fill: "url(#overcast-01_svg2__g)"
    },
    transform: "rotate(-45 33.894 33.88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 77.42h29.03v6.45H0z",
    style: {
      fill: "url(#overcast-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89 30.66h29.03v6.45h-29.03z",
    style: {
      fill: "url(#overcast-01_svg2__i)"
    },
    transform: "rotate(-44.99 127.415 33.881)"
  }));
};
export default SvgOvercast01;